import { Account } from '@/domain/usecases'
import { QueryClient } from 'react-query'
import { LoaderResponse } from '../base-loader'
import SimpleImageLoader from '../simple-image-loader'
import InternalCompanyManagerBaseLoader from './internal-company-manager-base-loader'

export default class InternalCompanyManagerSimpleImageLoader extends InternalCompanyManagerBaseLoader {
  constructor(
    readonly account: Account.Model,
    private readonly importImageModule: Promise<{ default: string }>,
    readonly queryClient: QueryClient
  ) {
    super(account, queryClient)
  }

  loader(): LoaderResponse {
    return this.defer(new SimpleImageLoader(this.account, this.importImageModule).loader)
  }
}
